<script setup>
import { onBeforeMount, onMounted } from 'vue'
import axios from "axios";
import Analytics from "src/composables/Analytics";

const { get_cid } = Analytics();

onBeforeMount(() => {
  const cookies = document.cookie.split(/\s*;\s*/).map(cookie => cookie.split('='))
  const accessTokenCookie = cookies.find(x => x[0] === 'my-access-token')

  if (!accessTokenCookie) {
    localStorage.removeItem('sb-login-auth-token')
  }
})

onMounted(() => {
  setTimeout(() => {
    const tag_manager_not_defined = window.google_tag_manager === undefined;
    const datalayer_not_defined = window.dataLayer === undefined;
    if (tag_manager_not_defined || datalayer_not_defined) {
      axios.post(`https://us-central1-cp-services-304516.cloudfunctions.net/CP_Webhooks`,
          {
            event_data: {
              visitor: {
                cid: get_cid()
              },
              datalayer_not_defined,
              tag_manager_not_defined
            }
          },
          {
            headers: {
              cp_source: 'cp2'
            }
          })
    }
  }, 5000)
})
</script>

<template>
  <router-view/>
</template>

